import { roles } from '@shared/static/roles';

//------- cards
export function formatCardNumber(cardNumber) {
  if (!cardNumber) return '';
  return `${cardNumber.slice(0, 4)} ${cardNumber.slice(4, 6)}… ${cardNumber.slice(-4)}`;
}

export function formatCardNumberSpaces(cardNumber) {
  if (!cardNumber) return '';
  return cardNumber.match(/.{1,4}/g).join(' ');
}

export function getTotalActiveHoldCards(data) {
  return (data?.cardsCount?.active ?? 0) + (data?.cardsCount?.hold ?? 0);
}

export function getTotalCards(data) {
  return getTotalActiveHoldCards(data) + (data?.cardsCount?.block ?? 0);
}
//-------

//------- forms
export function isEmptyObject(value) {
  return Object.keys(value).length === 0;
}

export function getDirtyValues(dirtyFields, allValues) {
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;
  return Object.fromEntries(
    Object.keys(dirtyFields).map((key) => [
      key,
      getDirtyValues(dirtyFields[key], allValues[key]),
    ]),
  );
}
//-------

//------- strings
export function formatWalletAddress(address, startChars = 5, endChars = 5) {
  if (!address) return '';
  if (address.length <= startChars + endChars) return address;

  const start = address.slice(0, startChars);
  const end = address.slice(-endChars);
  return `${start}…${end}`;
}

export function formatShareUrlLink(url, endChars = 6) {
  if (!url) return '';

  try {
    const { hostname } = new URL(url);
    if (url.length <= 20) return hostname;
    return `${hostname}…${url.slice(-endChars)}`;
  } catch {
    return url;
  }
}

export function copyToClipboard(text) {
  return navigator.clipboard.writeText(text);
}
//-------

//------- teams
export function hasActiveTeamLead(member, allGroups) {
  if (member?.group_role !== roles.TEAM_MEMBER) return false;

  const group = allGroups?.find((g) => g.id === member.groups?.[0]?.id);
  return Boolean(group?.teamLead?.id);
}
//-------
